import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'admin-requests'
const plural = 'admin-requests'
const single = 'admin-request'

const api = new ApiCore({
	index: true,
	findOne: true,
	findAll: false,
	create: false,
	update: true,
	remove: true,
	url: url,
	plural: plural,
	single: single
})

api.approveRequest = (params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/approve`, params)
		.then(handleResponse)
		.catch(handleError);
}

api.rejectRequest = (params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/reject`, params)
		.then(handleResponse)
		.catch(handleError);
}

api.getRequest = (requestId) => {
	return axios
			.get(`${apiProvider.BASE_URL}/${url}/${requestId}`)
			.then(handleResponse)
			.catch(handleError);
}


export default api
